import { render } from "./Contact.vue?vue&type=template&id=2dc2c1d7&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=2dc2c1d7&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/hnaccountancy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc2c1d7"]])

export default __exports__